import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GoogleCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (token) {
      localStorage.setItem("token", token);
      window.location.href = "/account/home";
    } else {
      navigate("/auth/signin");
    }
  }, [navigate]);

  return (
    <div>
      Processing...
    </div>
  )
}

export default GoogleCallback
